import theme from '../../theme';
export var BOTTOM_SHEET_DEFAULT_STYLES = {
    overlay: {
        backgroundColor: '#00000080',
        zIndex: 1000,
        display: theme.style.display.flex,
        alignItems: theme.style.alignItems.flexEnd,
        justifyContent: theme.style.justifyContent.center,
    },
    content: {
        position: 'fixed',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        border: 'none',
        background: 'transparent',
        padding: 0,
        width: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'visible',
    },
};
export var BOTTOM_SHEET_DEFAULT_CONFIG = {
    tension: 300,
    friction: 30,
    closeThreshold: 100,
    closeVelocityThreshold: 0.3,
    borderRadius: theme.typography.border.radius.xxxLarge,
    maxHeightRatio: 0.8,
};
